import axios from "../../../lib/axios";
import { AxiosResponse } from "axios";
import { TResponse } from "../../../types/common";

export async function getCmsConfig<T>(page: string): Promise<
  AxiosResponse<TResponse<T>>
> {
  return axios.get<TResponse<T>>(`/cms/${page}/details`);
}

export async function saveCmsConfig<T>(
  page: string,
  data: Partial<T>
): Promise<AxiosResponse<TResponse<T>>> {
  return axios.post<TResponse<T>>(`/cms/${page}/save`, data);
}
